/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Feedback_Yes_Option_After_LinkInputs */

const en_ai_feedback_yes_option_after_link = /** @type {(inputs: Ai_Feedback_Yes_Option_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_ai_feedback_yes_option_after_link = /** @type {(inputs: Ai_Feedback_Yes_Option_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` habe ich gelesen.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Ai_Feedback_Yes_Option_After_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_feedback_yes_option_after_link = /** @type {((inputs?: Ai_Feedback_Yes_Option_After_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Feedback_Yes_Option_After_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_feedback_yes_option_after_link(inputs)
	return en_ai_feedback_yes_option_after_link(inputs)
});